import { BeneficiariesSubformType } from '../types';

export const defaultValues: BeneficiariesSubformType = {
  beneficiaries: [],
};
